import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'
import routes from './router'
import '../src/styles/styles.css'
import 'element-plus/dist/index.css'
import ElementPlus from 'element-plus'
import { vAppear } from './directives/v-appear'

const router = createRouter({
  history: createWebHistory(),
  routes
})

const app = createApp(App)
app.directive('appear', vAppear)
app.use(router)
app.use(ElementPlus)
app.mount('#app')


